import {useCallback, useEffect, useState} from "react";
import '@inovua/reactdatagrid-community/index.css'
import {useFormikContext} from "formik";
import CustomDataGrid from "../../table/CustomDataGrid";

const columns = [
    {name: 'gebouw', header: 'Gebouw', minWidth: 300},
    {name: 'boa', header: 'BOA', defaultFlex: 1, minWidth: 50, type: 'number'},
    {name: 'ohddc', header: 'OHDDC', defaultFlex: 1, minWidth: 50, type: 'number'},
    {name: 'ohveld', header: 'OHVELD', defaultFlex: 1, minWidth: 50, type: 'number'},
];

// Table with the buildings
const BuildingTable = () => {
    const {values, setFieldValue} = useFormikContext();
    const {service_form_project_building, service_form_project_data_building} = values

    const [dataSource, setDataSource] = useState(service_form_project_data_building);

    useEffect(() => {
        // Check how many building there are and make a datasource with the same amount of rows
        let b = parseInt(service_form_project_building)
        if(b > dataSource.length) {
            const temp = []
            for (let i = dataSource.length; i < b; i++) {
                temp.push({
                    id: i,
                    gebouw: "",
                    boa: 0,
                    ohddc: 0,
                    ohveld: 0,
                })
            }
            setDataSource([...dataSource, ...temp])
        }
        if(b < dataSource.length) {
            setDataSource([...dataSource.slice(0,b)])
        }
    }, [service_form_project_building])

    // Set the context values when the data source changes
    useEffect(() => {

        const totals = dataSource.reduce((prev, curr) => {
            prev.boa = prev.boa + parseInt(curr.boa || 0)
            prev.ohddc = prev.ohddc + parseInt(curr.ohddc || 0)
            prev.ohveld = prev.ohveld + parseInt(curr.ohveld || 0)
            return prev
        }, {
            boa: 0,
            ohddc: 0,
            ohveld: 0
        })
        setFieldValue("service_form_project_data_building",dataSource)
        setFieldValue("service_form_project_building_totals", totals)
    }, [dataSource])

    // This function is used to update the data source when a cell is edited
    const onEditCompleteUren = useCallback(({value, columnId, rowId}) => {
        const data = [...dataSource];

        data[rowId][columnId] = parseInt(value) || value;
        setDataSource(data);
    }, [dataSource])


    return <CustomDataGrid
            idProperty="id"
            onEditComplete={onEditCompleteUren}
            editable={true}
            columns={columns}
            dataSource={dataSource}
            multiSelect={false}
            isStartEditKeyPressed={({event}) => event.key === "Enter"}
        />
}


export default BuildingTable;